import React from 'react';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
// import FullLayout2 from '../../../components/FullLayout';
import Header from '../../asyncIntake/Header';
import { useState } from 'react';
import { LearnMoreModal } from '../../asyncIntake/screens/LearnMoreModal';
import FullLayout2 from '../../asyncIntake/screens/components/FullLayout';
import { isMobile } from 'react-device-detect';

const SuperContainer = styled(Flex)`
  width: 100vw;
  justify-content: center;
  z-index: 1;
  overflow-y: auto;
  flex: 1;
`;

const Container = styled(Flex)`
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  margin-top: 80px;
  z-index: 1;
  position: relative;
  overflow-y: none;
  margin-bottom: 36px;
  flex-direction: column;
  align-items: center;
`;

const Expandable = ({ text, title }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <Card mb={3} flex={1}>
      <Flex flexDirection={'column'} flex={1} style={{ cursor: 'pointer', margin: '12px 20px' }}>
        <Flex
          alignItems={'center'}
          style={{ gap: '20px' }}
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          <Text flex={1} style={{ fontSize: '15px', fontWeight: 500 }}>
            {title}
          </Text>
          <Text style={{ fontSize: '33px', fontWeight: 300 }}>+</Text>
        </Flex>
        {isExpanded && (
          <Text style={{ fontSize: 12, marginTop: 8, fontWeight: 400, whiteSpace: 'pre-line' }} mb={3}>
            {text}
          </Text>
        )}
      </Flex>
    </Card>
  );
};

const ListItem = ({ text, description }) => {
  return (
    <Flex mb={'10px'}>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_31_1240)">
          <ellipse cx="7.39633" cy="7.39611" rx="4.49057" ry="3.69811" fill="#344F7A" />

          <mask id="mask0_31_1240" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
            <path
              d="M6.99984 12.8334C7.76602 12.8344 8.52484 12.6839 9.2327 12.3907C9.94056 12.0975 10.5835 11.6673 11.1246 11.1248C11.667 10.5837 12.0972 9.9408 12.3904 9.23294C12.6837 8.52509 12.8341 7.76627 12.8332 7.00009C12.8341 6.2339 12.6837 5.47509 12.3904 4.76723C12.0972 4.05937 11.667 3.41643 11.1246 2.87534C10.5835 2.33288 9.94056 1.90269 9.2327 1.60948C8.52484 1.31626 7.76602 1.16581 6.99984 1.16675C6.23366 1.16581 5.47484 1.31626 4.76698 1.60948C4.05913 1.90269 3.41618 2.33288 2.87509 2.87534C2.33264 3.41643 1.90245 4.05937 1.60923 4.76723C1.31602 5.47509 1.16556 6.2339 1.16651 7.00009C1.16556 7.76627 1.31602 8.52509 1.60923 9.23294C1.90245 9.9408 2.33264 10.5837 2.87509 11.1248C3.41618 11.6673 4.05913 12.0975 4.76698 12.3907C5.47484 12.6839 6.23366 12.8344 6.99984 12.8334Z"
              fill="white"
              stroke="white"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path d="M4.6665 7L6.4165 8.75L9.9165 5.25" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </mask>

          <g mask="url(#mask0_31_1240)">
            <path d="M0 0H14V14H0V0Z" fill="#CFFEE6" />
          </g>
        </g>

        <defs>
          <clipPath id="clip0_31_1240">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <Flex ml={2} flex={1} flexDirection={'column'}>
        <Text style={{ color: 'white', fontSize: '12px', fontWeight: 500, lineHeight: '17px' }}>{text}</Text>
        {!!description && <Text style={{ color: 'white', fontSize: '10px', fontWeight: 400, lineHeight: '14px' }}>{description}</Text>}
      </Flex>
    </Flex>
  );
};

export const UpgradePro = ({ continueWithProKit, continueWithoutProKit }) => {
  return (
    <FullLayout2 pb={5} style={{ zIndex: 11, overflowY: isMobile ? 'hidden' : 'auto', overflowX: 'hidden', maxHeight: '100vh' }}>
      <Header dark={false} mb={3} />
      <SuperContainer>
        <Container padding={'0 40px'}>
          <Heading textAlign={'center'} mb={3} style={{ fontSize: '26px' }}>
            Upgrade to The Pro Gut Health Test
          </Heading>
          <Text style={{ fontWeight: 500, fontSize: '17px', textAlign: 'center', margin: '0 20px' }} mb={3}>
            Get deeper, more actionable insights for just +$165
          </Text>
          <Card mt={3} style={{ width: '292px', maxWidth: '292px', borderRadius: '20px', position: 'relative', overflow: 'hidden', padding: '13px 23px 27px 23px', flex: 'initial' }}>
            <svg style={{ position: 'absolute', right: 0, top: 0 }} xmlns="http://www.w3.org/2000/svg" width="181" height="167" viewBox="0 0 181 167" fill="none">
              <path
                opacity="0.2"
                d="M119.899 -55.1346C145.086 -48.2019 167.287 -36.6287 186.244 -18.8374C191.826 -13.4823 197.675 -8.41148 203.769 -3.64433C227.162 14.239 232.508 38.7175 228.38 65.6787C224.009 94.2242 211.931 119.638 190.515 139.5C170.143 158.391 145.038 167.779 117.468 166.539C105.904 166.018 93.9311 159.915 83.345 154.146C59.7392 141.285 39.6635 123.769 21.0169 104.351C2.96495 85.5444 -2.11206 63.3115 0.744007 38.8137C3.65302 13.8423 13.1393 -9.06149 27.1164 -29.7597C40.6979 -49.8713 61.0022 -58.2412 84.9081 -57.8383C96.5806 -57.6448 108.237 -56.0803 119.899 -55.1346Z"
                fill="#7992B3"
                fill-opacity="0.5"
              />
            </svg>
            <Flex flexDirection={'column'} style={{ zIndex: 1 }}>
              <Heading style={{ fontSize: '18px', lineHeight: '30px' }} textAlign={'center'}>
                Pro Gut Health Test Add-on
              </Heading>
              <Text style={{ fontSize: '12px', fontWeight: 400, textAlign: 'center', lineHeight: '17px', marginTop: '10px', alignSelf: 'center', justifySelf: 'center' }}>
                Unlock a more comprehensive look at your gut health with the Pro Test, which includes everything in the standard GI test— plus enhanced biomarkers, including:
              </Text>
              <Flex
                mt={3}
                flexDirection={'column'}
                style={{ width: '100%', backgroundColor: '#354E79', borderRadius: '10px', alignSelf: 'center', padding: '12px 14px', position: 'relative', zIndex: 1 }}
              >
                <ListItem text={'Digestion & absorption markers'} />
                <ListItem text={'Immune function markers'} />
                <ListItem text={'SCFA concentrations'} description={'butyrate, acetate, propionate, valerate'} />
                <ListItem text={'Inflammation markers'} description={'Lactoferrin, lysozyme, calprotectin'} />
                <ListItem text={'Intestinal health markers'} description={'pH, beta-glucuronidase, occult blood'} />
              </Flex>
              <Flex alignItems={'center'} justifyContent={'center'}>
                <Button
                  mt={3}
                  variant={'pink'}
                  style={{
                    alignSelf: 'center',
                    fontWeight: 300,
                    padding: '8px 14px',
                  }}
                  onClick={() => {
                    continueWithProKit();
                  }}
                >
                  Upgrade for $165
                </Button>
              </Flex>
            </Flex>
          </Card>
          <Text
            mt={3}
            textAlign={'center'}
            style={{ color: '#44A5FF', fontSize: '14px', cursor: 'pointer', fontWeight: 500, textDecoration: 'underline' }}
            onClick={() => {
              continueWithoutProKit();
            }}
          >{`No thanks, continue >`}</Text>

          <Text style={{ fontSize: '18px', fontWeight: 600 }} mt={4} mb={3}>
            Who should take the PRO test?
          </Text>
          <Flex flexDirection={'column'} flex={1}>
            <Expandable
              title={'Adults with chronic or new GI symptoms'}
              text={
                'Adults with a history of GI issues or a new issues - the PRO kit inflammation markers can help to identify microbial and non-microbial sources of gut inflammation, helping to better pinpoint root causes of symptoms'
              }
            />
            <Expandable
              title={'Those with symptoms related to food'}
              text={
                'For those with symptoms related to food, or for those wanting to optimize nutrition, the PRO kit digestive-related insights can help tailor next steps based on their personalized results'
              }
            />
            <Expandable
              title={'Women with hormonal related conditions such as PMS, PCOS or peri-menopause'}
              text={
                'For women with PMS, who are perimenopausal or experiencing other hormonal-related symptoms - assessing beta-glucuronidase is key. This enzyme can play a role in estrogen levels and is a detoxifier. Beta-glucuronidase can influence how medications and environmental toxins are eliminated from the body.'
              }
            />
          </Flex>
          <Flex alignItems={'center'} justifyContent={'center'}>
            <Button
              mt={2}
              variant={'pink'}
              style={{
                alignSelf: 'center',
                fontWeight: 300,
                padding: '8px 14px',
              }}
              onClick={() => {
                // console.log('CWPK')
                continueWithProKit();
              }}
            >
              Upgrade for $165
            </Button>
          </Flex>
        </Container>
      </SuperContainer>
    </FullLayout2>
  );
};
